import TextToolTip from "@lhd/components/TextToolTip";
import { ICellRendererParams } from "ag-grid-community";

const CellTextDefault = (params: Partial<ICellRendererParams>) => {
  const value = params.valueFormatted ?? params.value;

  return (
    <div
      style={{
        width: "100%",
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      <TextToolTip style={{ flex: 1, minWidth: 0 }}>{value}</TextToolTip>
    </div>
  );
};

export default CellTextDefault;
